import { useEffect, useState } from "react";
import { ProductCard, ProductCardSkeleton } from "@/components/ProductCard";
import { getOffers } from "@/lib/api";

export default function Offers() {
  const [products, setProducts] = useState(null);
  useEffect(() => {
    getOffers().then(setProducts).catch(() => setProducts([]));
  }, []);

  return (
    <div className="mx-auto w-full max-w-page px-4 py-10 sm:px-6 lg:px-8" data-testid="offers-page">
      <header className="mb-8">
        <h1 className="font-display text-3xl font-extrabold tracking-tight text-foreground sm:text-4xl">Offerte</h1>
        <p className="mt-2 text-muted-foreground">Tutti i prodotti con un'offerta attiva in questo momento.</p>
      </header>

      {products === null ? (
        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
          {Array.from({ length: 8 }).map((_, i) => <ProductCardSkeleton key={i} />)}
        </div>
      ) : products.length === 0 ? (
        <div className="rounded-2xl bg-card p-10 text-center">
          <p className="text-lg font-semibold text-foreground">Nessuna offerta attiva al momento</p>
          <p className="mt-1 text-muted-foreground">Torna a trovarci presto.</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4" data-testid="offers-grid">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
